import React, { useState } from "react";
import "../../../styles/template.css";

export default function OptionsChipEditor({ value = [], onChange }) {

  const [input, setInput] = useState("");

  const addOption = () => {

    const v = input.trim();
    if (!v) return;

    if (!value.includes(v)) {
      onChange([...value, v]);
    }

    setInput("");
  };

  const removeOption = (i) => {

    const next = [...value];
    next.splice(i,1);

    onChange(next);
  };

  return (
    <div className="options-chip-editor">
    <div className="chip-editor">
      <div className="chip-list">
        {value.map((opt, i) => (
          <span key={i} className="chip" >
            {opt}
            <button className="btn-chip" onClick={() => removeOption(i)}>x</button>
          </span>
        ))}
      </div>
      <input
        value={input}
        onChange={(e)=>setInput(e.target.value)}
        onKeyDown={(e)=>{
          if(e.key==="Enter"){
            e.preventDefault();
            addOption();
          }
        }}
        placeholder="Add option..."
      />
    </div>
    </div>
  );
}
